import { PasswordRecoveryForm } from "./password-recovery/PasswordRecoveryForm";
import type { PasswordRecoveryFormProps } from "./password-recovery/types";

export const PasswordRecovery = ({ onBack, onTokenRecovery }: PasswordRecoveryFormProps) => {
  return <PasswordRecoveryForm onBack={onBack} onTokenRecovery={onTokenRecovery} />;
};